import React from 'react';
import {
  Box,
  Flex,
  Text,
  Stack,
  Link as ChakraLink,
  Icon,
  Divider,
  useColorModeValue,
} from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaTwitter, FaInstagram, FaEnvelope } from 'react-icons/fa';

const DashboardFooter = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.900'); // Lighter background for light mode, darker for dark mode
  const textColor = useColorModeValue('gray.600', 'gray.300'); // Adjust text color for better contrast

  return (
    <Box as="footer" bg={bgColor} color={textColor} py={8} px={4}>
      <Flex
        maxW="1200px"
        mx="auto"
        direction={{ base: 'column', md: 'row' }}
        align="center"
        justify="space-between"
        spacing={6}
      >
        <Text mb={{ base: 4, md: 0 }} fontSize="sm">
          &copy; {new Date().getFullYear()} PurelyGive. All rights reserved.
        </Text>
        <Stack
          direction={{ base: 'column', sm: 'row' }}
          spacing={{ base: 2, sm: 4 }}
          align="center"
        >
          <ChakraLink as={Link} to="/" _hover={{ color: 'blue.500' }}>
            Home
          </ChakraLink>
          <ChakraLink as={Link} to="/privacy-policy" _hover={{ color: 'blue.500' }}>
            Privacy Policy
          </ChakraLink>
          <ChakraLink as={Link} to="/terms-and-conditions" _hover={{ color: 'blue.500' }}>
            Terms & Conditions
          </ChakraLink>
          <ChakraLink as={Link} to="/contact" _hover={{ color: 'blue.500' }}>
            Contact Us
          </ChakraLink>
        </Stack>
      </Flex>
      <Divider my={6} borderColor={useColorModeValue('gray.300', 'gray.700')} />
      <Flex
        maxW="1200px"
        mx="auto"
        align="center"
        justify={{ base: 'center', md: 'flex-end' }}
        spacing={4}
      >
        <Stack direction="row" spacing={4}>
          <ChakraLink href="https://www.facebook.com/purelygive" isExternal aria-label="Facebook">
            <Icon as={FaFacebook} boxSize={5} _hover={{ color: 'blue.500' }} />
          </ChakraLink>
          <ChakraLink href="https://twitter.com/purelygive" isExternal aria-label="Twitter">
            <Icon as={FaTwitter} boxSize={5} _hover={{ color: 'blue.500' }} />
          </ChakraLink>
          <ChakraLink href="https://www.instagram.com/purelygive" isExternal aria-label="Instagram">
            <Icon as={FaInstagram} boxSize={5} _hover={{ color: 'blue.500' }} />
          </ChakraLink>
          <ChakraLink href="mailto:sam@purelygive.com" aria-label="Email">
            <Icon as={FaEnvelope} boxSize={5} _hover={{ color: 'blue.500' }} />
          </ChakraLink>
        </Stack>
      </Flex>
    </Box>
  );
};

export default DashboardFooter;
